import { useRef, useCallback } from 'react';

export const useDebounce = (func, timeout = 300) => {
  const timerRef = useRef(null);
  const debounced = useCallback((...args) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  }, []);
  return debounced;
};
